export default "__VITE_ASSET__ChVCGJN8__"